export const RouteName = Object.freeze({
  CONTACT_US: { path: "/contact-us" },
  LOGIN: { path: "/login" },
  HOTELS: { path: "/hotels" },
  ABOUT_US: { path: "/about-us" },
  HOTEL_DETAIL: { path: "/hotel" },
  BOOKING: { path: "/booking" },
  CHECKOUT: { path: "/checkout" },
  FORGOT_PASSWORD: { path: "/forgot-password" },
  REGISTER: { path: "/register" },
  USER_PROFILE: { path: "/user-profile" },
  TOURS: { path: "/tours" },
});